import { render, staticRenderFns } from "./buddyList.vue?vue&type=template&id=2178d6cd&scoped=true&"
import script from "./buddyList.vue?vue&type=script&lang=js&"
export * from "./buddyList.vue?vue&type=script&lang=js&"
import style0 from "./buddyList.vue?vue&type=style&index=0&id=2178d6cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178d6cd",
  null
  
)

export default component.exports